import React from "react";

export const DropDownIcon = () => (
    <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 1.58979L9.5 11.0898L19 1.58979C18.8003 0.242262 18.4574 -0.213195 17 0.0897945L9.5 7.58979L2 0.0897945C0.45111 -0.054589 0.107254 0.366464 0 1.58979Z" fill="black"/>
    </svg>
);

export const DropDownUpIcon = () => (
    <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 9.50005L9.5 4.86374e-05L0 9.50005C0.199705 10.8476 0.542609 11.303 2 11L9.5 3.50005L17 11C18.5489 11.1444 18.8927 10.7234 19 9.50005Z" fill="black"/>
    </svg>
);